import React, { useEffect, useState } from "react";

// DTOs
import { Cidade } from "../../dto/Cidade";
import { UF } from "../../dto/Uf";
import { UserInfo } from "../../dto/UserInfo";

// Serviços
import { BuscaCepService } from "../../services/BuscaCepService";
import { CidadeService } from "../../services/CidadeService";

// Helpers
import { mostraMensagemErro, mostraMensagemSucesso } from '../../helpers/Notificacoes';
import { useNavigate } from "react-router-dom";


export const useLocalidade = () => {

    const buscaCepService = new BuscaCepService();
     const navigate = useNavigate();

    const cidadeService = new CidadeService(() => {
        navigate('/mvp', {
            state: {
                propsPage: 'login'
            }
        });
    });


    const [userInfo,] = useState<UserInfo>(JSON.parse(localStorage.getItem('udbs')!));

    const [cidades, setCidades] = useState<Cidade[] | []>([])
    const [cidadeSelecionada, setCidadeSelecionada] = useState<Cidade | null>();
    const [uf, setUf] = useState<UF[]>([])
    const [ufSelecionada, setUfSelecionada] = useState<UF>();
    const [haveUf, sethaveUf] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);
    const [nomesCidades, setNomesCidades] = useState([]);
    const nomesUfs = uf.map(obj => obj.nome);

    async function buscaCidadesUf(idUf: string) {
        setIsLoading(true);
        setCidades([]);
        const response = await cidadeService.get(`/v1/cidades/${idUf}`);

        if (response.codigo !== 200) {
            setIsLoading(false);
            return;
        } else {
            if (response.status === 0) {
                mostraMensagemErro('Erro ao buscar cidades.');
                setIsLoading(false);
            } else {
                const cidadesOrdenadas = response.status.sort((a: any, b: any) =>
                    a.nome.localeCompare(b.nome)
                );

                setCidades(cidadesOrdenadas);
                const nomesCidades = cidadesOrdenadas.map((obj: { nome: string; }) => obj.nome);
                setNomesCidades(nomesCidades);
                setIsLoading(false);
                sethaveUf(false);
                return cidadesOrdenadas;
            }
        }

        setIsLoading(false);
    }

    useEffect(() => {
        const buscaUFs = async () => {
            setIsLoading(true);

            if (uf.length === 0) {
                const response = await cidadeService.get('/v1/ufs');

                if (response.codigo !== 200) {
                    setIsLoading(false);
                    return;

                } else {

                    if (response.status.length === 0) {
                        mostraMensagemErro('Erro ao buscar cidade.');
                        setIsLoading(false);

                    } else {

                        const ufsOrdenadas = response.status.sort((a: any, b: any) => a.nome.localeCompare(b.nome));
                        setUf(ufsOrdenadas);
                        setIsLoading(false);
                    }
                }
            }
            setIsLoading(false);
        }
        buscaUFs();
    }, [userInfo]);

    useEffect(() => {
        const buscaCidades = async () => {
            if (!ufSelecionada) {
                return;
            }
            await buscaCidadesUf(ufSelecionada.idUf);
        }
        buscaCidades();
    }, [ufSelecionada])


    async function buscaUfById(idUf: string) {
        try {
            const ufSelecionada = await cidadeService.get(`/v1/uf/${idUf}`);
            return ufSelecionada.status;
        } catch (erro) {
            mostraMensagemErro('Erro ao buscar UF.');
            return;
        }
    }

    async function buscaCidadeById(idCidade: string) {
        try {
            const cidade = await cidadeService.get(`/v1/cidade/${idCidade}`);
            return cidade.status;

        } catch (erro) {
            mostraMensagemErro('Erro ao buscar cidade.');
            return;
        }
    }


    return {
        cidades,
        setCidades,
        cidadeSelecionada,
        setCidadeSelecionada,
        uf,
        ufSelecionada,
        setUfSelecionada,
        buscaCidadesUf,
        haveUf,
        isLoading,
        nomesCidades,
        nomesUfs,
        buscaCidadeById,
        buscaUfById
    }
}